import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getComponents } from "src/components/app/getComponents";
import HeroBanner from "src/components/app/homescreen/HeroBanner/HeroBanner";
import PoweredByLogo from "src/components/app/homescreen/PoweredByLogo";
import DocumentStatusCard from "src/components/app/review-state/DocumentStatusCard";
import ProgramBenefits from "src/components/app/review-state/ProgramBenefits";
import ProgramDetailsCard from "src/components/app/review-state/ProgramDetailsCard";
import analytics from "src/helpers/analytics";
import { SCREEN_NAMES } from "src/helpers/analytics/events";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as deviceActions from "src/redux/slices/deviceSlice";
import * as cgmActions from "src/redux/slices/cgmSlice";

interface HomeScreenProps {
  screenData: any;
  supportProgramKey: any;
}

const HomeScreen: React.FC<HomeScreenProps> = ({
  screenData,
  supportProgramKey,
}) => {
  const navigate = useNavigate();
  const { patient } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const heroBanner = screenData.components?.find(
    (component: any) => component.id === "hero-section"
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    // page view
    analytics.pageView(SCREEN_NAMES.HOME_SCREEN);

    // get connected devices
    getConnectedDevices();
    dispatch(cgmActions.getCgmStatusRequest());
  }, [dispatch]);

  const getConnectedDevices = () => {
    new Promise((resolve, reject) => {
      dispatch(deviceActions.getConnectedDevicesRequest({ resolve, reject }));
    });
  };

  const paidUser = Number(patient?.data?.paidUser) === 1;

  if (!paidUser) {
    const poweredByLogo = screenData.components?.find(
      (component: any) => component.id === "powered-by-logo"
    );
    return (
      <>
        <HeroBanner {...heroBanner} supportProgramKey={supportProgramKey} />
        <DocumentStatusCard supportProgramKey={supportProgramKey} />
        <ProgramDetailsCard supportProgramKey={supportProgramKey} />
        <ProgramBenefits supportProgramKey={supportProgramKey} />
        <PoweredByLogo
          supportProgramKey={supportProgramKey}
          imageUrl={poweredByLogo.image_url}
        />
      </>
    );
  }

  return (
    <>
      {Array.isArray((screenData as any)?.components) &&
        (
          screenData as unknown as { components: { id: string }[] }
        ).components.map((component) =>
          getComponents(component, navigate, supportProgramKey)
        )}
    </>
  );
};

export default HomeScreen;
